// src/components/DevSeoGuard.jsx
import React from "react";
import { useLocation } from "react-router-dom";

export default function DevSeoGuard() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    if (process.env.NODE_ENV !== "development") return;
    const t = document.title || "";
    const desc = document.querySelector('meta[name="description"]')?.content || "";
    const can = document.querySelector('link[rel="canonical"]')?.href || "";

    const issues = [];
    if (!t) issues.push("• Missing <title>");
    if (!desc) issues.push("• Missing <meta name='description'>");
    if (!can) issues.push("• Missing <link rel='canonical'>");

    if (issues.length) {
      // eslint-disable-next-line no-console
      console.warn(`[SEO] ${pathname}\n${issues.join("\n")}`);
    }
  }, [pathname]);

  return null;
}
